import React from 'react';

export const AnchorPoint = props => {
  const { data } = props || {};
  const anchor = data?.primary?.name?.text;
  return anchor && <div id={anchor} style={{ display: 'hidden' }}></div>;
};
